export const supportLinks = [
  {
    label: 'Shipping',
    href: '/shipping',
  },
  {
    label: 'Return, Refund & Exchange Policy',
    href: '/return-refund-exchange-policy',
  },
  {
    label: 'Contact Us',
    href: '/contact-us',
  },
  {
    label: 'Term Of Service',
    href: '/terms-of-service',
  },
  {
    label: 'Privacy Policy',
    href: '/privacy-policy',
  },
  {
    label: 'Payment Policy',
    href: '/payment-options',
  },
];
